var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1149_429",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.381713,
    y: 0.381713,
    width: 17.5588,
    height: 17.359,
    rx: 8.67951,
    fill: "#D9D9D9",
    stroke: "#BEB58B",
    strokeWidth: 0.763426
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1149_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58105 15.8486C4.01008 15.8486 3.44531 15.7106 2.88666 15.4343C2.68513 15.3346 2.4977 15.2236 2.32433 15.1011C2.14399 14.9737 2.10838 14.7595 2.16382 14.5413C2.21927 14.323 2.36545 14.1032 2.54461 13.9686C2.89092 13.7085 3.06374 13.3311 3.06374 12.8378C3.06374 12.211 3.28539 11.6786 3.7289 11.24C4.17242 10.8013 4.71075 10.582 5.34447 10.582C5.97819 10.582 6.51653 10.8013 6.96004 11.24C7.40355 11.6786 7.62521 12.211 7.62521 12.8378C7.62521 13.6658 7.32725 14.3744 6.73102 14.9641C6.13478 15.5539 5.4183 15.8486 4.58105 15.8486ZM10.0022 10.2939C9.43074 10.8592 8.51075 10.8592 7.93926 10.2939C7.35883 9.71979 7.35883 8.78226 7.93926 8.20816L13.7107 2.49964C13.8488 2.36303 14.0214 2.29153 14.2291 2.28531C14.4364 2.27909 14.6152 2.35041 14.7661 2.49964L15.7967 3.51903C15.9477 3.66839 16.0229 3.84219 16.0229 4.04082C16.0229 4.23945 15.9477 4.41325 15.7967 4.56261L10.0022 10.2939Z",
    fill: "#BEB58B",
    stroke: "#BEB58B",
    strokeWidth: 0.0190857
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrush);
export default __webpack_public_path__ + "static/media/icon-brush.7b608c883fa3865aa74f3b7f5fb65521.svg";
export { ForwardRef as ReactComponent };